/**
 * Clears storage if the hostname has changed
 * Prevents issues when the same browser is used across different instances
 */
export const clearStorageIfNeeded = () => {
  // Get the last hostname from storage
  const lastHostname = localStorage.getItem('last-hostname');
  const currentHostname = window.location.hostname;
  
  // If hostname has changed, clear local storage
  if (lastHostname && lastHostname !== currentHostname) {
    localStorage.clear();
    sessionStorage.clear();
  }
  
  // Update the stored hostname
  localStorage.setItem('last-hostname', currentHostname);
}; 